import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3003/api';

// Tạo axios instance
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Request interceptor - thêm token vào mọi request
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor - xử lý lỗi
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token hết hạn hoặc không hợp lệ
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Auth APIs
export const authAPI = {
  login: (credentials) => api.post('/auth/login', credentials),
  register: (data) => api.post('/auth/register', data),
  getProfile: () => api.get('/auth/profile'),
  changePassword: (data) => api.post('/auth/change-password', data)
};

// Template APIs
export const templateAPI = {
  getAll: () => api.get('/templates'),
  getById: (id) => api.get(`/templates/${id}`),
  create: (data) => api.post('/templates', data),
  update: (id, data) => api.put(`/templates/${id}`, data),
  delete: (id) => api.delete(`/templates/${id}`),
  syncFromZalo: () => api.post('/sync/templates')
};

// ZNS APIs
export const znsAPI = {
  send: (data) => api.post('/zns/send', data),
  sendBulk: (formData) => api.post('/zns/send-bulk', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }),
  downloadTemplateFile: (templateId) => api.get(`/zns/download-template/${templateId}`, {
    responseType: 'blob'
  }),
  getHistory: (params) => api.get('/zns/history', { params }),
  getStatistics: () => api.get('/zns/statistics')
};

// User Management APIs
export const userAPI = {
  getModules: () => api.get('/users/modules'),
  getAll: () => api.get('/users'),
  create: (data) => api.post('/users', data),
  update: (id, data) => api.put(`/users/${id}`, data),
  updatePermissions: (id, permissions) => api.put(`/users/${id}/permissions`, { permissions }),
  toggleActive: (id) => api.patch(`/users/${id}/toggle`),
  resetPassword: (id, new_password) => api.post(`/users/${id}/reset-password`, { new_password }),
  delete: (id) => api.delete(`/users/${id}`)
};

// Activity Log APIs
export const activityAPI = {
  getLogs: (params) => api.get('/activity-logs', { params })
};

export default api;